import { Link } from "react-router-dom";
import { CompetitionFields } from "./CompetitionFields";
import moment from "moment-timezone";

export const CompetitionValues = ({ competition, field }) => {
  switch (field) {
    case CompetitionFields.name:
      return (
        <div className="text-nowrap text-truncate w-100">
          <Link to={`/competitions/${competition.id}`}>{competition.name}</Link>
        </div>
      );
    case CompetitionFields.start_date:
      return (
        <span className="text-nowrap">
          {moment(competition.start_date).format("DD/MM/YYYY")}
        </span>
      );
    case CompetitionFields.start_date_small:
      return (
        <span className="text-nowrap">
          {moment(competition.start_date).format("DD/MM")}
        </span>
      );
    case CompetitionFields.zipcode:
      return competition.zipcode;
    case CompetitionFields.department:
      return competition.department;
    case CompetitionFields.city:
      return competition.city;
    default:
      return null;
  }
};
